import React, { useState, createContext } from 'react';
import { IForm } from './interface';
import { validators } from './validators';

const Form: React.FC<IForm> = ({
  children,
  id,
  onValidate,
  className,
  customFunction,
  title,
  disableEnterSubmit = false,
}) => {
  const [fail, setFail] = useState(false);

  const handleOnSubmit = (e: any) => {
    e.persist();
    e.preventDefault();

    const elements = [].slice.call(e.target.elements);
    const validation: Array<boolean | string> = [];

    const data: any = {};
    const validatedStates = new Set<string>();

    elements.forEach((input: any) => {
      const stateName = input.getAttribute('data-stateName');
      const inputType = input.type;

      if (stateName) {
        data[stateName] = input?.value || undefined;
      }

      const isTrimWhiteSpace = input.getAttribute('data-istrimwhitespace');
      const maxDescriptionLength = input.getAttribute('data-maxlength');

      if (input.id === 'discountValue') {
        return validation.push(
          validators['text'](
            input.value,
            input.name,
            null,
            input.required,
            null,
            true
          )
        );
      }

      if (input.id === 'description' && isTrimWhiteSpace) {
        return validation.push(
          validators['textAreaOutRangeLength'](
            input.value,
            input.name,
            input.minLength,
            input.required,
            maxDescriptionLength,
          )
        );
      }

      if (inputType === 'radio' && stateName && !validatedStates.has(stateName)) {
        validatedStates.add(stateName);

        const isChecked = elements.some(
          (item: any) =>
            item.getAttribute('data-stateName') === stateName &&
            item.checked
        );

        if (!isChecked) {
          return validation.push(
            validators['radio'](
              input.name,
              input.required
            )
          );
        }

        return validation.push(false);
      }

      if (inputType === 'file') {
        validatedStates.add(stateName);
        return validation.push(
          validators['file'](
            input.files?.[0] || null,
            input.name,
            null,
            input.required,
          )
        );
      }

      if (validators[inputType]) {
        validatedStates.add(stateName);
        return validation.push(
          validators[inputType](
            input.value,
            input.name,
            input.minLength,
            input.required,
            {
              name: input.getAttribute('data-comparename'),
              value: input.getAttribute('data-comparevalue'),
              stateName: stateName
            }
          )
        );
      }

      if (validators[input.getAttribute('data-customtype')]) {
        return validation.push(
          validators[input.getAttribute('data-customtype')](
            input.value,
            input.name,
            input.required
          )
        );
      }

      return validation.push(false);
    });

    if (validation.every((ev) => ev === false)) {
      customFunction && customFunction(false);
      return onValidate(data);
    }

    customFunction && customFunction(true);
    return setFail(true);
  };


  const handleKeyDownInput = (event: React.KeyboardEvent<HTMLFormElement>) => {
    if (disableEnterSubmit && event.key === 'Enter') {
      event.preventDefault();
    }
  };

  return (
    <form
      className={className}
      id={id}
      noValidate
      title={title || ''}
      onSubmit={(e) => handleOnSubmit(e)}
      onKeyDown={handleKeyDownInput}
      role='form'
    >
      <FailContext.Provider value={fail}>{children}</FailContext.Provider>
    </form>
  );
};

export const FailContext = createContext(false);
export default Form;
